import { css } from 'linaria';

export const headerSection = css`
  && {
    background-color: #21282B;

    section:first-of-type {
      height: 100%;
      overflow: visible;

      @media (--only-desktop) {
        margin-bottom: 40px;
      }
    }
}`;

export const headerCategories = css`
  && {
    section:first-of-type {
      background-color: #21282B;
      margin-bottom: 0;

      @media (--only-desktop) {
        margin-bottom: 24px;
      }

      p {
        font-size: 16px;
        line-height: 22px;
      }

      @media (--only-mobile) {
        margin-bottom: 8px;
      }
    }
  }
`;

export const headerSectionWrapper = css`
  @media (--to-desktop) {
    padding: 0;
    margin: 0;
  }
`;

export const headerImage = css`
  && {
    @media (--only-largeDesktop) {
      width: 660px;
      height: 100%;
      left: 530px;
    }

    @media (--only-desktop) {
      width: 459px;
      height: 207px;
      left: 500px;
      top: 66px;
    }

    @media (--only-tablet) {
      height: 308px;
      width: 100%;
    }
  }
`;

export const headerSectionText = css`
  && {
    @media (--only-largeDesktop) {
      width: 536px;
      margin-top: 70px;
    }

    @media (--only-desktop) {
      width: 454px;
      margin-top: 40px;
    }

    @media (--only-tablet) {
      padding-bottom: 0;
    }

    @media (--only-mobile) {
      padding: 24px 0 0 0;
    }
  }
`;

export const headerSectionTitle = css`
  && {
    margin-bottom: 24px;
  }
`;

export const headerSectionDescription = css`
  @media (--only-mobile) {
    display: none;
  }
`;
